import {
  useMemo,
  Children,
  type JSX,
  type ElementType,
  type ComponentProps,
} from 'react';
import {
  useRecipe,
  Heading as ChakraHeading,
  type HeadingProps as ChakraHeadingProps,
} from '@chakra-ui/react';

import type { ExtraProps } from 'react-markdown';

import { headingRecipe } from './recipe';

export function Heading({
  node,
  ...rest
}: ComponentProps<'h1'> & ExtraProps): JSX.Element {
  const { tagName } = node || {};
  const level = Number(tagName?.replace('h', '') || '1');

  const recipe = useRecipe({
    recipe: headingRecipe,
  });

  const defaultProps = useMemo<ChakraHeadingProps>(() => {
    return {
      fontSize: `${32 - (level - 1) * 3}px`,
    };
  }, [level]);

  return (
    <ChakraHeading
      css={recipe}
      as={(node?.tagName as ElementType) || 'h1'}
      id={`${level}-${Children.toArray(rest.children).join('-')}-${node?.position?.start.line}`}
      {...defaultProps}
      {...rest}
    />
  );
}
